export default {
  title: "Container Management",
  subtitle: "Cross-company overview of all containers with VIP data",
  filters: {
    search: "Search container, booking, BL...",
    company: "All companies",
    status: "All statuses",
  },
  table: {
    title: "Containers",
    description: "All platform containers",
    headers: {
      container: "Container",
      booking: "Booking",
      company: "Company",
      consignee: "Consignee",
      route: "Route",
      carrier: "Carrier / Vessel",
      dates: "ETD / ETA",
      vip: "VIP %",
      risk: "Risk",
      status: "Status",
      docs: "Docs",
    },
    empty: {
      title: "No containers found",
      message: "Try adjusting your search filters",
    },
  },
  detail: {
    title: "Container Detail",
    vipFields: "VIP Fields",
    editFields: "Edit fields",
    analyze: "Analyze with Agent",
    analyzing: "Analyzing...",
    save: "Save changes",
    saving: "Saving...",
    saved: "Changes saved successfully",
    saveError: "Error saving changes",
    sources: "Sources",
    confidence: "Confidence",
    noSources: "No sources",
    fieldLabels: {
      container_number: "Container Number",
      carrier: "Carrier",
      origin_port: "Origin Port",
      destination_port: "Destination Port",
      consignee_name: "Consignee",
      etd: "ETD",
      eta: "ETA",
      cargo_value: "Cargo Value",
      cargo_description: "Cargo Description",
      cargo_details: "Cargo Details",
      hs_code: "HS Code",
    },
    status: {
      missing: "Missing",
      uncertain: "Uncertain",
      confirmed: "Confirmed",
    },
    agentResult: "Agent Result",
    analyzeError: "Analysis error",
    decision: {
      CREATE: "Create new",
      LINK: "Link existing",
      REVIEW: "Needs review",
      SKIP: "Skip",
    },
  },
  loading: "Loading...",
};
